import { App } from '@Modules/App';

$.validator.addMethod(
  'minNumberOfColors',
  function (value) {
    const existfiles = App.pageData('currenteditedcontent.screenPrintingFiles');
    const screenPrintChecked = $('#screenPrintPartCheckbox').is(':checked');
    if (!screenPrintChecked || existfiles.length) {
      return true;
    }
    return value > 0;
  },
  'Please enter a number greater than 0!'
);

$.validator.addMethod(
  'greaterThan',
  function (value, element, param) {
    return this.optional(element) || parseFloat(value) > param;
  },
  'Please enter a value greater than or equal to {0}.'
);

export const ValidationRules = {
  login: {
    user: {
      required: true
      //email   : true
    },
    password: {
      required: true
    }
  },

  signup: {
    fullname: {
      required: true
    },
    email: {
      required: true,
      email: true
    },
    password: {
      required: true
    },
    rpassword: {
      required: true
    },
    agree: {
      required: true
    }
  },

  passwordForgot: {
    email: {
      required: true,
      email: true
    }
  },

  artworkDialogForm: {
    title: {
      required: true,
      maxlength: 200
    },
    fileName_0: {
      required: function (element) {
        let jElement = $('[name="fileName_2"]');
        if (!jElement.length) return true;
        let result = jElement.val() == '';
        return result;
      },
      success: function (label) {
        let formGroup = $(label).closest('.form-group');
        if (formGroup.length) {
          formGroup.removeClass('is-invalid');
        }
      }
    },
    fileName_1: {
      required: function (element) {
        let jElement = $('[name="fileName_2"]');
        if (!jElement.length) return true;
        let result = jElement.val() == '';
        return result;
      },
      success: function (label) {
        let formGroup = $(label).closest('.form-group');
        if (formGroup.length) {
          formGroup.removeClass('is-invalid');
        }
      }
    },
    //fileName_11: 'required',
    description: {
      required: false,
      maxlength: 1000
    },
    brand: {
      required: true,
      maxlength: 100
    },
    subbrand: {
      required: false,
      maxlength: 100
    },
    screenNumberOfColors: 'minNumberOfColors',
    licensorId: 'required'
  },

  artworkVersionForm: {
    versionName: {
      required: true,
      maxlength: 100
    },
    colorGroup: {
      required: true
    }
  },

  blankDialogForm: {
    title: 'required'
  },

  mpdForm: {
    title: {
      required: true,
      maxlength: 200
    },
    description: {
      required: false,
      maxlength: 500
    },
    brand: {
      required: false,
      maxlength: 100
    },
    subbrand: {
      required: false,
      maxlength: 100
    },
    licensorRoyalty: {
      required: false,
      number: true,
      range: [0, 100]
    },
    licenseeRoyalty: {
      required: false,
      number: true,
      range: [0, 100]
    },
    agentRoyalty: {
      required: false,
      number: true,
      range: [0, 100]
    },
    storesWithLanguagesField: {
      required: function () {
        if (App.pageData('mpd_currenteditedcontent.masterProductData.storesWithLanguages').length == 0) return true;
        else return false;
      }
    },
    productName: {
      required: true,
      maxlength: 200
    },
    defaultPriceCurrencyValue: {
      required: true,
      number: true,
      greaterThan: 0
    },
    skuPrefix: 'required'
  },

  mpdFormMessage: {
    storesWithLanguagesField: {
      required: 'Please add at least one store.'
    }
  },

  mpdAddMockupDialog: {
    mockupType: 'required',
    imageType: 'required',
    color: 'required',
    fileExtension: 'required',
    fileName_0: 'required',
    fileName: 'required'
  },

  mpdAddPrintfileDialog: {
    fileName_0: 'required',
    areaType: 'required',
    alignment: 'required'
  },

  stampDialogForm: {
    title: 'required',
    fileName_0: 'required'
  },

  businessEditForm: {
    name: {
      required: true
    },
    email: {
      required: true,
      email: true
    }
  },

  commerceEditForm: {
    royaltyRate: {
      required: true
    }
  },

  userCreateFrom: {
    userGroups: {
      required: true,
      pattern: /^[0-9a-zA-Z!\"#$%&'()*+,-.:;<=>?@\[\]^_`{|}~]*$/
    },
    userName: {
      required: true,
      pattern: /^\S*$/
    },
    fullName: 'required',
    password: {
      required: true,
      minlength: 6,
      pattern: /^[0-9a-zA-Z!\"#$%&'()*+,-.:;<=>?@\[\]^_`{|}~]*$/
    },
    confirmpassword: {
      equalTo: 'input[name="password"]'
    },
    email: {
      required: true,
      email: true
    }
  },

  licensorForm: {
    name: 'required',
    email: {
      required: true,
      email: true
    }
  },

  sendApprovalDialog: {
    fullName: 'required',
    email: {
      required: true,
      email: true
    }
  },

  sendSampleDialog: {
    address: {
      required: true,
      pattern: /^[a-zA-Z0-9-\/] ?([a-zA-Z0-9-\/]|[a-zA-Z0-9-\/] )*[a-zA-Z0-9-\/]$/
    },
    city: 'required',
    state: 'required',
    postalAddress: {
      required: false,
      zipcode: true
    },
    phone: {
      required: false,
      phone: true
    }
  },

  briefForm: {
    title: 'required'
  },

  trimForm: {
    title: 'required',
    trimType: 'required',
    licensorId: 'required',
    fileName_1: 'required',
    brand: {
      required: true,
      maxlength: 100
    },
  },
  stampForm: {
    title: 'required',
    licensorId: 'required',
    fileName_1: 'required',
    brand: {
      required: true,
      maxlength: 100
    },
  },
  styleGuideForm: {
    title: 'required',
    filevalidate: 'required'
  }
};
